import React, { useContext } from "react";
import MainContext from "./context/main/mainContext";
import InternalDemoTeamForm from "./checkout/components/InternalDemoTeamForm";
import StripeInvoice from "./StripeInvoice";
import TeamSubscriptionForm from "./checkout/components/TeamSubscriptionForm";
import TeamSubscriptionWrapper from "./checkout/components/TeamSubscriptionWrapper";

const StripeHome = () => {
  const mainContext = useContext(MainContext);
  const { stripe_subscription_extended } = mainContext;

  // Page to show
  let component = (
    <>
      <p>🤔</p>
    </>
  );

  if (stripe_subscription_extended) {
    component = (
      <>
        <StripeInvoice />
      </>
    );
  } else {
    component = (
      <>
        <TeamSubscriptionWrapper />
      </>
    );
  }

  return <div>{component}</div>;
};

export default StripeHome;
